<div data-testid="criteria-evaluation-page">
  @if (isEc3()) {
    <app-ec3-module-group
      [moduleTabs]="ec3ModuleTabs()"
      [subCriteriaPanels]="subCriteriaPanels()"
      [disabled]="disabled()"
      [projectId]="projectId()"
      [showConsistency]="showConsistency()"
      [lastSaveAuditInfo]="lastSaveAuditInfo()"
      (scoreSelected)="onScoreSelected($event)"
      (save)="onSave($event)"
      (consistencyChanged)="onConsistencyChanged($event)"
    />
  } @else if (hasSubCriteria()) {
    <p-tabs
      appTabsUnsavedReveal
      [value]="activeSubCriteriaTabIndex()"
      (valueChange)="onSubCriteriaSelected($event!)"
      data-testid="subcriteria-tabs"
      scrollable
    >
      <p-tablist data-testid="subcriteria-tablist">
        @for (panel of subCriteriaPanels(); track panel.id) {
          <p-tab
            [value]="$index"
            [appTabStatus]="panel.status"
            [attr.data-testid]="'subcriteria-tab-' + panel.id"
          >
            {{ panel.translations | translateDirectus }}
            @if (showConsistency() && panel.unresolvedConsistencyCount > 0) {
              <i
                class="pi pi-exclamation-triangle ml-2 text-sm"
                [style.color]="
                  panel.clarificationConsistencyCount > 0
                    ? consistencyClarificationColor
                    : consistencyWarningColor
                "
                [pTooltip]="'evaluation.consistency.tabWarning' | transloco"
                [attr.data-testid]="'subcriteria-tab-warning-' + panel.id"
              ></i>
            }
          </p-tab>
        }
      </p-tablist>
      <p-tabpanels class="mt-6" data-testid="subcriteria-tabpanels">
        <p-card data-testid="subcriteria-card">
          @for (panel of subCriteriaPanels(); track panel.id) {
            <p-tabpanel [value]="$index" [attr.data-testid]="'subcriteria-tabpanel-' + panel.id">
              <app-sub-criteria-tab
                [subCriteriaPanel]="panel"
                [disabled]="disabled()"
                [projectId]="projectId()"
                [phase]="phase"
                [showConsistency]="showConsistency()"
                [lastSaveAuditInfo]="lastSaveAuditInfo()"
                (scoreSelected)="onScoreSelected($event)"
                (save)="onSave(panel.id)"
                (consistencyChanged)="onConsistencyChanged($event)"
              />
            </p-tabpanel>
          }
        </p-card>
      </p-tabpanels>
    </p-tabs>
  } @else {
    <p-card>
      <div class="text-center py-12" data-testid="no-subcriteria-message">
        <i class="pi pi-info-circle text-4xl text-gray-400 mb-4"></i>
        <h3 class="text-lg font-semibold text-gray-600 mb-2">
          {{ 'project.steps.noSubCriteriaTitle' | transloco }}
        </h3>
        <p class="text-gray-500 max-w-md mx-auto">
          {{ 'project.steps.noSubCriteriaMessage' | transloco }}
        </p>
      </div>
    </p-card>
  }
</div>
